import { AfterViewInit, ViewChild, Component, OnInit, Renderer2, ElementRef, Input } from '@angular/core';
import { environment } from "src/environments/environment";
import { OAuthService } from "angular-oauth2-oidc";
import { HttpClient, HttpHeaders } from "@angular/common/http";

@Component({
  selector: 'app-chatbot-button',
  templateUrl: './chatbot-button.component.html',
  styleUrls: ['./chatbot-button.component.scss']
})
export class ChatbotButtonComponent implements OnInit, AfterViewInit {

  env = environment;
  @ViewChild('chatbotWidget', { static: false }) chatbot!: ElementRef;
  @Input() appID: number;

  userType: string = 'Parent';
  language: string = 'en';
  chatbotScriptUrl: string = this.env.chatbotScriptURL;
  chatbotAPIBaseURL: string = this.env.chatbotAPIBaseURL;

  constructor(
    private renderer: Renderer2,
    private el: ElementRef,
    private oAuthService: OAuthService,
    private http: HttpClient
  ) { }

  ngOnInit(): void {
    this.verifyAccessAndLoadScript();    
  }

  ngAfterViewInit(): void {

  }

  
  verifyAccessAndLoadScript(): void{

    if (this.env.enableChatbot == false) {
      return;
    }

    let customheaders = new HttpHeaders({
      Authorization: `${this.oAuthService.authorizationHeader()}`
    });
    let url = `${this.chatbotAPIBaseURL}/chat/verifyaccess`
  
    this.http.post(url, {}, { headers: customheaders }).subscribe({
      next: (response: any) => {

        if (response?.can_access == "1") {
          this.loadChatScript();
        };
      },
      error: (error) => {
        // console.error("API Error:", error);
        // this.showChatbot = false; // Hide chatbot if API fails
        // this.showError = true;
      },
    });

  }



  loadChatScript() {



    if (!document.querySelector(`script[src="${this.chatbotScriptUrl}"]`)) {
      const script = this.renderer.createElement('script');
      script.src = this.chatbotScriptUrl;
      script.onload = () => {
        this.initializeChatbot(); // Ensure script is loaded before calling methods
      };
      document.body.appendChild(script);
    }
    else {
      this.initializeChatbot();
    }
  }



  initializeChatbot() {

    const chatbotElement = this.chatbot.nativeElement as any;

    if (chatbotElement) {
      chatbotElement.setAuthToken(this.oAuthService.authorizationHeader());
      chatbotElement.setAppID(this.appID);
      chatbotElement.setUserType(this.userType);
      chatbotElement.setDeviceType(window.navigator.userAgent);
      
      console.log('CB initialized');
    } else {
      console.error('CB widget error');
    }
  }

  


  removeChatBot() {
    // 1. Find and remove the script tag
    const script = document.querySelector(`script[src="${this.chatbotScriptUrl}"]`);
    if (script) {
      this.renderer.removeChild(document.body, script);
    }

    // 2. Clean up the chatbot element/widget
    const chatbotElement = this.chatbot.nativeElement as any;
    if (chatbotElement) {      
      if (typeof chatbotElement.remove === 'function') {
        chatbotElement.remove();
      }
    }
  }
}
